import { formatCurrency } from '@angular/common';
import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'payRangeText',
    standalone: true
})
export class PayRangeTextPipe implements PipeTransform {
    transform(
        isAlternating: boolean,
        payLow: number,
        payHigh: number,
        altPayLow: number,
        altPayHigh: number,
        isBasedOnExperiencePay = false
    ): string {
        if (isBasedOnExperiencePay) {
            return 'Based On Experience';
        }

        if (!isAlternating || (payLow === altPayLow && payHigh === altPayHigh)) {
            return this.getPayRangeText(payLow, payHigh);
        } else {
            return this.getAltPayRangeText(payLow, payHigh, altPayLow, altPayHigh);
        }
    }

    getPayRangeText(payLow: number, payHigh: number): string {
        if (payLow === 0 && payHigh > 0) {
            return `Up to ${this.formatCurrency(payHigh)}`;
        } else if (payLow > 0 && payLow !== payHigh) {
            return `${this.formatCurrency(payLow)} to ${this.formatCurrency(payHigh)}`;
        } else if (payLow > 0 && payLow === payHigh) {
            return this.formatCurrency(payHigh);
        } else {
            return 'Contact AM';
        }
    }

    getAltPayRangeText(payLow: number, payHigh: number, altPayLow: number, altPayHigh: number): string {
        if (payLow === 0 && payHigh > 0) {
            return `Up to ${this.formatCurrency(payHigh)} / ${this.formatCurrency(altPayHigh)}`;
        } else if (payLow > 0 && payLow !== payHigh) {
            return `${this.formatCurrency(payLow)} / ${this.formatCurrency(altPayLow)} to ${this.formatCurrency(
                payHigh
            )} / ${this.formatCurrency(altPayHigh)}`;
        } else if (payLow > 0 && payLow === payHigh) {
            return `${this.formatCurrency(payHigh)} / ${this.formatCurrency(altPayHigh)}`;
        } else {
            return 'Contact AM';
        }
    }

    formatCurrency(num: number): string {
        return formatCurrency(num, 'en-US', '$', '', '1.2-2');
    }
}
